export enum VoltageTypes {
  KV11 = 0,
  KV33 = 1,
}
